export type IconsId =
  | 'youtube'
  | 'wishlist'
  | 'wishlist-fill'
  | 'twitter'
  | 'tree'
  | 'tick'
  | 'tag'
  | 'sun'
  | 'star'
  | 'star-half'
  | 'star-empty'
  | 'snowflake'
  | 'sing-out'
  | 'share'
  | 'settings'
  | 'search2'
  | 'search'
  | 'screwdriver'
  | 'ruler'
  | 'radio-on'
  | 'radio-off'
  | 'print'
  | 'pound'
  | 'plus'
  | 'play'
  | 'pinterest'
  | 'phone3'
  | 'phone2'
  | 'phone'
  | 'payment'
  | 'pause'
  | 'minus'
  | 'menu'
  | 'login'
  | 'lock'
  | 'location'
  | 'livechat'
  | 'leaf'
  | 'instagram'
  | 'information'
  | 'info-2'
  | 'home'
  | 'help'
  | 'grid-4'
  | 'grid-4-fill'
  | 'grid-3'
  | 'grid-3-fill'
  | 'grid-2'
  | 'grid-2-fill'
  | 'grid-1'
  | 'grid-1-fill'
  | 'four'
  | 'four-circle'
  | 'flower'
  | 'flower-2'
  | 'filter'
  | 'facebook'
  | 'express'
  | 'experience'
  | 'email'
  | 'delivery'
  | 'copy'
  | 'collection'
  | 'close'
  | 'clock'
  | 'clickcollect'
  | 'chevron-up'
  | 'chevron-right'
  | 'chevron-left'
  | 'chevron-down'
  | 'chat'
  | 'card'
  | 'basket'
  | 'autumn'
  | 'arrow-up'
  | 'arrow-left'
  | 'arrow-down'
  | 'account2'
  | 'account'
  | 'account-filled';

export type IconsKey =
  | 'Youtube'
  | 'Wishlist'
  | 'WishlistFill'
  | 'Twitter'
  | 'Tree'
  | 'Tick'
  | 'Tag'
  | 'Sun'
  | 'Star'
  | 'StarHalf'
  | 'StarEmpty'
  | 'Snowflake'
  | 'SingOut'
  | 'Share'
  | 'Settings'
  | 'Search2'
  | 'Search'
  | 'Screwdriver'
  | 'Ruler'
  | 'RadioOn'
  | 'RadioOff'
  | 'Print'
  | 'Pound'
  | 'Plus'
  | 'Play'
  | 'Pinterest'
  | 'Phone3'
  | 'Phone2'
  | 'Phone'
  | 'Payment'
  | 'Pause'
  | 'Minus'
  | 'Menu'
  | 'Login'
  | 'Lock'
  | 'Location'
  | 'Livechat'
  | 'Leaf'
  | 'Instagram'
  | 'Information'
  | 'Info2'
  | 'Home'
  | 'Help'
  | 'Grid4'
  | 'Grid4Fill'
  | 'Grid3'
  | 'Grid3Fill'
  | 'Grid2'
  | 'Grid2Fill'
  | 'Grid1'
  | 'Grid1Fill'
  | 'Four'
  | 'FourCircle'
  | 'Flower'
  | 'Flower2'
  | 'Filter'
  | 'Facebook'
  | 'Express'
  | 'Experience'
  | 'Email'
  | 'Delivery'
  | 'Copy'
  | 'Collection'
  | 'Close'
  | 'Clock'
  | 'Clickcollect'
  | 'ChevronUp'
  | 'ChevronRight'
  | 'ChevronLeft'
  | 'ChevronDown'
  | 'Chat'
  | 'Card'
  | 'Basket'
  | 'Autumn'
  | 'ArrowUp'
  | 'ArrowLeft'
  | 'ArrowDown'
  | 'Account2'
  | 'Account'
  | 'AccountFilled';

export enum Icons {
  Youtube = 'youtube',
  Wishlist = 'wishlist',
  WishlistFill = 'wishlist-fill',
  Twitter = 'twitter',
  Tree = 'tree',
  Tick = 'tick',
  Tag = 'tag',
  Sun = 'sun',
  Star = 'star',
  StarHalf = 'star-half',
  StarEmpty = 'star-empty',
  Snowflake = 'snowflake',
  SingOut = 'sing-out',
  Share = 'share',
  Settings = 'settings',
  Search2 = 'search2',
  Search = 'search',
  Screwdriver = 'screwdriver',
  Ruler = 'ruler',
  RadioOn = 'radio-on',
  RadioOff = 'radio-off',
  Print = 'print',
  Pound = 'pound',
  Plus = 'plus',
  Play = 'play',
  Pinterest = 'pinterest',
  Phone3 = 'phone3',
  Phone2 = 'phone2',
  Phone = 'phone',
  Payment = 'payment',
  Pause = 'pause',
  Minus = 'minus',
  Menu = 'menu',
  Login = 'login',
  Lock = 'lock',
  Location = 'location',
  Livechat = 'livechat',
  Leaf = 'leaf',
  Instagram = 'instagram',
  Information = 'information',
  Info2 = 'info-2',
  Home = 'home',
  Help = 'help',
  Grid4 = 'grid-4',
  Grid4Fill = 'grid-4-fill',
  Grid3 = 'grid-3',
  Grid3Fill = 'grid-3-fill',
  Grid2 = 'grid-2',
  Grid2Fill = 'grid-2-fill',
  Grid1 = 'grid-1',
  Grid1Fill = 'grid-1-fill',
  Four = 'four',
  FourCircle = 'four-circle',
  Flower = 'flower',
  Flower2 = 'flower-2',
  Filter = 'filter',
  Facebook = 'facebook',
  Express = 'express',
  Experience = 'experience',
  Email = 'email',
  Delivery = 'delivery',
  Copy = 'copy',
  Collection = 'collection',
  Close = 'close',
  Clock = 'clock',
  Clickcollect = 'clickcollect',
  ChevronUp = 'chevron-up',
  ChevronRight = 'chevron-right',
  ChevronLeft = 'chevron-left',
  ChevronDown = 'chevron-down',
  Chat = 'chat',
  Card = 'card',
  Basket = 'basket',
  Autumn = 'autumn',
  ArrowUp = 'arrow-up',
  ArrowLeft = 'arrow-left',
  ArrowDown = 'arrow-down',
  Account2 = 'account2',
  Account = 'account',
  AccountFilled = 'account-filled',
}

export const ICONS_CODEPOINTS: { [key in Icons]: string } = {
  [Icons.Youtube]: '61697',
  [Icons.Wishlist]: '61698',
  [Icons.WishlistFill]: '61699',
  [Icons.Twitter]: '61700',
  [Icons.Tree]: '61701',
  [Icons.Tick]: '61702',
  [Icons.Tag]: '61703',
  [Icons.Sun]: '61704',
  [Icons.Star]: '61705',
  [Icons.StarHalf]: '61706',
  [Icons.StarEmpty]: '61707',
  [Icons.Snowflake]: '61708',
  [Icons.SingOut]: '61709',
  [Icons.Share]: '61710',
  [Icons.Settings]: '61711',
  [Icons.Search2]: '61712',
  [Icons.Search]: '61713',
  [Icons.Screwdriver]: '61714',
  [Icons.Ruler]: '61715',
  [Icons.RadioOn]: '61716',
  [Icons.RadioOff]: '61717',
  [Icons.Print]: '61718',
  [Icons.Pound]: '61719',
  [Icons.Plus]: '61720',
  [Icons.Play]: '61721',
  [Icons.Pinterest]: '61722',
  [Icons.Phone3]: '61723',
  [Icons.Phone2]: '61724',
  [Icons.Phone]: '61725',
  [Icons.Payment]: '61726',
  [Icons.Pause]: '61727',
  [Icons.Minus]: '61728',
  [Icons.Menu]: '61729',
  [Icons.Login]: '61730',
  [Icons.Lock]: '61731',
  [Icons.Location]: '61732',
  [Icons.Livechat]: '61733',
  [Icons.Leaf]: '61734',
  [Icons.Instagram]: '61735',
  [Icons.Information]: '61736',
  [Icons.Info2]: '61737',
  [Icons.Home]: '61738',
  [Icons.Help]: '61739',
  [Icons.Grid4]: '61740',
  [Icons.Grid4Fill]: '61741',
  [Icons.Grid3]: '61742',
  [Icons.Grid3Fill]: '61743',
  [Icons.Grid2]: '61744',
  [Icons.Grid2Fill]: '61745',
  [Icons.Grid1]: '61746',
  [Icons.Grid1Fill]: '61747',
  [Icons.Four]: '61748',
  [Icons.FourCircle]: '61749',
  [Icons.Flower]: '61750',
  [Icons.Flower2]: '61751',
  [Icons.Filter]: '61752',
  [Icons.Facebook]: '61753',
  [Icons.Express]: '61754',
  [Icons.Experience]: '61755',
  [Icons.Email]: '61756',
  [Icons.Delivery]: '61757',
  [Icons.Copy]: '61758',
  [Icons.Collection]: '61759',
  [Icons.Close]: '61760',
  [Icons.Clock]: '61761',
  [Icons.Clickcollect]: '61762',
  [Icons.ChevronUp]: '61763',
  [Icons.ChevronRight]: '61764',
  [Icons.ChevronLeft]: '61765',
  [Icons.ChevronDown]: '61766',
  [Icons.Chat]: '61767',
  [Icons.Card]: '61768',
  [Icons.Basket]: '61769',
  [Icons.Autumn]: '61770',
  [Icons.ArrowUp]: '61771',
  [Icons.ArrowLeft]: '61772',
  [Icons.ArrowDown]: '61773',
  [Icons.Account2]: '61774',
  [Icons.Account]: '61775',
  [Icons.AccountFilled]: '61776',
};
